/* Modulo: Media Pitch — video behavior.
   Two jobs: (1) reduced-motion-gate + pause-offscreen for an autoplaying uploaded
   video; (2) lazy-iframe lightbox for an external YouTube/Vimeo video.
   Vanilla IIFE. Sections can't use window.moduloLazyInit — roll our own + theme lifecycle. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─── External URL parsing (YouTube / Vimeo) ─── */
  function parseVideoUrl(url) {
    if (!url) return null;
    var m;
    m = url.match(/(?:youtube\.com\/(?:watch\?.*v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (m) return { provider: 'youtube', id: m[1] };
    m = url.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/);
    if (m) return { provider: 'vimeo', id: m[1] };
    return null;
  }

  function buildEmbedUrl(parsed) {
    if (!parsed) return '';
    if (parsed.provider === 'youtube') {
      return 'https://www.youtube.com/embed/' + parsed.id + '?autoplay=1&rel=0';
    }
    if (parsed.provider === 'vimeo') {
      return 'https://player.vimeo.com/video/' + parsed.id + '?autoplay=1';
    }
    return '';
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  /* ─── Per-section init (idempotent) ─── */
  function initSection(section) {
    if (!section || section.__mpInit) return;
    section.__mpInit = true;

    /* (1) Autoplaying uploaded video */
    var video = section.querySelector('[data-modulo-mp-video][data-mp-autoplay="true"]');
    if (video) {
      if (REDUCE) {
        video.removeAttribute('autoplay');
        video.controls = true;
        try { video.pause(); } catch (e) {}
      } else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.25 });
        io.observe(video);
        section.__mpIO = io;
      }
    }

    /* (2) External video lightbox */
    var trigger = section.querySelector('[data-modulo-mp-lightbox]');
    var modal = section.querySelector('[data-modulo-mp-lightbox-modal]');
    if (trigger && modal) {
      var body = modal.querySelector('[data-modulo-mp-lightbox-body]');
      var closeBtn = modal.querySelector('[data-modulo-mp-lightbox-close]');
      var url = trigger.getAttribute('data-mp-url');

      function openModal() {
        var parsed = parseVideoUrl(url);
        if (!parsed) return;
        var embed = buildEmbedUrl(parsed);
        if (!embed) return;

        var iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Video player');

        clearChildren(body);
        body.appendChild(iframe);
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        modal.__prevFocus = document.activeElement;
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        clearChildren(body); // removing the iframe stops playback
        document.body.style.overflow = '';
        if (modal.__prevFocus && modal.__prevFocus.focus) modal.__prevFocus.focus();
      }

      trigger.addEventListener('click', openModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });

      section.__mpCloseModal = closeModal;
      section.__mpModal = modal;
    }
  }

  /* ─── Escape closes any open lightbox ─── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.modulo-mp__lightbox[aria-hidden="false"]');
    if (!open) return;
    var section = open.closest('[data-modulo-mp]');
    if (section && section.__mpCloseModal) section.__mpCloseModal();
  });

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-modulo-mp]');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* ─── Theme editor lifecycle ─── */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (!el) return;
    if (el.matches && el.matches('[data-modulo-mp]')) {
      el.__mpInit = false;
      initSection(el);
    } else {
      initAll(el);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target;
    if (!el) return;
    var section = (el.matches && el.matches('[data-modulo-mp]')) ? el : (el.querySelector ? el.querySelector('[data-modulo-mp]') : null);
    if (!section) return;
    if (section.__mpIO) section.__mpIO.disconnect();
    if (section.__mpModal && section.__mpModal.getAttribute('aria-hidden') === 'false' && section.__mpCloseModal) {
      section.__mpCloseModal();
    }
  });
})();
